import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExpandableContainerComponent } from "./expandable-container.component";
import { CardModule } from "../card/card.module";

@NgModule({
	declarations: [ExpandableContainerComponent],
	imports: [CommonModule, CardModule],
	exports: [ExpandableContainerComponent]
})
export class ExpandableContainerModule {}
